// Vizitka saytlar — xizmat sahifasi kontenti (uz / ru)
// Shakl: src/content/services/_shape.js

const uz = {
    meta: {
        title: "Vizitka sayt yaratish — narxi 5 mln so'mdan | Innobek",
        description:
            "Vizitka sayt yaratish 5 000 000 so'mdan. Kichik biznes va mutaxassislar uchun 3–5 sahifali sayt 7–12 kunda tayyor: mobil moslashuv, aloqa shakli, Google xaritasi.",
        keywords: [
            "vizitka sayt yaratish",
            "vizitka sayt narxi",
            "kichik biznes uchun sayt",
            "3 sahifali sayt",
            "Toshkentda sayt yasash",
            "mutaxassis uchun shaxsiy sayt",
        ],
    },
    hero: {
        eyebrow: "Vizitka saytlar",
        h1: "Vizitka sayt yaratish — kichik biznes uchun 3–5 sahifa",
        lead:
            "Kompaniya haqida, xizmatlar, ishlar va aloqa — hammasi o'z sahifasida, ortiqcha murakkablik yo'q. Vizitka sayt 7–12 ish kunida topshiriladi, telefonda mukammal ochiladi va Google qidiruvida topilishga tayyor holda beriladi.",
        ctaPrimary: "Bepul konsultatsiya",
        ctaSecondary: "Narxlarni ko'rish",
        proof: [
            "7–12 kunda topshirish",
            "3–5 ta sahifa",
            "Google xaritasi va ish vaqti",
            "6 oy texnik qo'llab-quvvatlash",
        ],
    },
    intro: {
        h: "Vizitka sayt nima va u kimga kerak?",
        p: [
            "Vizitka sayt — kompaniya yoki mutaxassis haqidagi asosiy ma'lumotni 3–5 sahifada ochib beradigan kichik veb-sayt. Odatda unda bosh sahifa, xizmatlar, biz haqimizda, ishlar va aloqa bo'ladi. Katta katalog, buyurtma tizimi yoki kundalik yangilanadigan bo'lim bo'lmaydi — shuning uchun vizitka sayt narxi ham, muddati ham korporativ saytnikidan sezilarli kam.",
            "Bunday sayt bitta savolga javob beradi: siz kimsiz va sizga nega ishonish mumkin. Mijoz Instagram'dan yoki tanish orqali sizni topganda, birinchi qiladigan ishi — ismingizni Google'da qidirish. O'sha paytda rasmiy sayt chiqsa, ishonch darajasi keskin ko'tariladi. Sayt bo'lmasa, mijoz raqobatchiga o'tib ketadi.",
            "Innobek vizitka saytni shablon to'ldirish sifatida ko'rmaydi. Avval faoliyatingizni, mijozingiz kim ekanini va qaysi ma'lumot unga muhimligini aniqlaymiz. Keyin sahifalar tuzilmasini shunga qarab tuzamiz: keraksiz bo'lim qo'shmaymiz, kerakli bo'limni esa qisqartirib yubormaymiz. Matn, rasm va tugmalar bitta maqsadga xizmat qiladi — bog'lanishni osonlashtirish.",
            "Vizitka sayt bilan landing page o'rtasidagi farq oddiy. Landing page bitta taklifni reklama ostida sotadi. Vizitka sayt esa kompaniyaning doimiy yuzi: unda bir nechta xizmat, jamoa, litsenziya va manzil bo'ladi. Agar sizda ikki-uchdan ortiq xizmat yo'nalishi bo'lsa, bitta sahifa tor keladi — shu paytda vizitka sayt to'g'ri tanlov.",
            "Halol aytamiz: vizitka sayt o'zi mijoz olib kelmaydi. U ishonchni mustahkamlaydi va bog'lanishni osonlashtiradi. Trafik uchun Google Business profili, SEO yoki reklama kerak bo'ladi. Shuning uchun biz saytni Google Business va Search Console'ga ulab topshiramiz — qidiruvda kompaniya nomi bo'yicha darhol topiladigan bo'ling.",
        ],
    },
    definition: {
        term: "Vizitka sayt nima?",
        text:
            "Vizitka sayt — kompaniya yoki mutaxassis haqidagi asosiy ma'lumot 3–5 sahifada joylashtirilgan kichik veb-sayt. Uning vazifasi — faoliyatni tushuntirish, ishonch uyg'otish va mijozga bog'lanish yo'lini ko'rsatish.",
    },
    included: {
        eyebrow: "Nimalar kiradi",
        h: "Har bir tarifda standart tarzda bor",
        sub: "Quyidagilar alohida to'lanadigan qo'shimcha emas — bazaviy tarifga ham kiradi.",
        items: [
            "Bepul konsultatsiya va sahifalar tuzilmasini rejalashtirish",
            "Domen tanlash va DNS sozlash bo'yicha yordam",
            "Bepul SSL sertifikati va HTTPS ulanish",
            "Telefon, planshet va kompyuterda tekshirilgan moslashuv",
            "Aloqa shakli hamda Telegram'ga xabar yuborish",
            "Google xaritasida manzil, ish vaqti va yo'nalish",
            "Meta teglar, sitemap.xml, robots.txt va Open Graph rasmi",
            "Google Analytics va Search Console'ga ulash",
            "Ijtimoiy tarmoq va messenjer tugmalari",
            "Topshirgandan keyin 6 oy texnik qo'llab-quvvatlash",
        ],
    },
    benefits: {
        eyebrow: "Afzalliklari",
        h: "Nega kichik biznesga aynan vizitka sayt yetarli",
        sub: "Katta sayt har doim ham foyda keltirmaydi. Quyida kichik formatning amaliy kuchli tomonlari.",
        items: [
            {
                t: "Byudjet oldindan aniq",
                d: "Sahifalar soni cheklangani uchun smeta boshida to'liq kelishiladi. Korporativ saytga nisbatan narx ikki barobardan ko'proq past, qo'shimcha to'lovlar esa yo'l-yo'lakay chiqmaydi.",
            },
            {
                t: "Bir-ikki haftada tayyor",
                d: "Uch sahifali variant 7 ish kunida, beshta sahifa va individual dizayn bilan 10–12 kunda topshiriladi. Mavsum boshlanishiga yoki tender muddatiga ulgurasiz.",
            },
            {
                t: "Ishonch darajasini ko'taradi",
                d: "Rasmiy sayt, INN, manzil va litsenziya nusxasi mijozning shubhasini kamaytiradi. Ayniqsa tibbiyot, yuridik va qurilish sohalarida bu to'g'ridan-to'g'ri murojaat soniga ta'sir qiladi.",
            },
            {
                t: "Google'da nom bo'yicha topiladi",
                d: "Kompaniya nomi bo'yicha qidiruvda birinchi o'rinda o'zingizning saytingiz turadi, ijtimoiy tarmoq havolasi yoki uchinchi tomon katalogi emas. Google Business profili bilan bog'lanadi.",
            },
            {
                t: "Ijtimoiy tarmoqqa bog'lanmaysiz",
                d: "Instagram akkaunti bloklansa yoki yo'qolsa, mijozlar siz bilan qanday bog'lanadi. Sayt — sizga tegishli va hech kim o'chira olmaydigan yagona kanal.",
            },
            {
                t: "Mobil birinchi o'rinda",
                d: "Tashriflarning katta qismi telefondan keladi, shuning uchun maket avval telefon ekrani uchun chiziladi. Raqam bosilganda qo'ng'iroq, manzil bosilganda xarita ochiladi.",
            },
            {
                t: "Keyin kengaytirsa bo'ladi",
                d: "Xizmatlar ko'paysa, blog yoki katalog kerak bo'lsa, saytga yangi bo'limlar qo'shiladi. Dizayn tizimi qayta ishlatilgani uchun kengaytirish noldan qurishdan arzon tushadi.",
            },
            {
                t: "Kod va materiallar sizniki",
                d: "Topshirishda domen, hosting kirish ma'lumotlari, Figma maketi va kod arxivi beriladi. Bizga bog'lanib qolmaysiz — saytni xohlagan paytda boshqa jamoa davom ettirishi mumkin.",
            },
        ],
    },
    audience: {
        eyebrow: "Kimga mos",
        h: "Vizitka sayt kimlar uchun eng foydali",
        sub: "Quyidagi holatlarda kichik sayt eng tejamkor va tez natija beradigan yechim hisoblanadi.",
        items: [
            {
                t: "Xususiy mutaxassislar",
                d: "Advokat, shifokor, psixolog, repetitor, dizayner, fotograf. Portfolio, xizmatlar ro'yxati va yozilish shakli — hammasi o'z sahifasida.",
            },
            {
                t: "Kichik xizmat kompaniyalari",
                d: "Ta'mirlash, logistika, buxgalteriya, yuridik xizmat, tozalash. Ikki-uch yo'nalish bo'lsa, har biriga alohida sahifa ajratiladi.",
            },
            {
                t: "Klinika va salonlar",
                d: "Xizmatlar va narxlar, jamoa, litsenziya, manzil va ish vaqti. Mijoz kelishdan oldin hamma savoliga javob topadi.",
            },
            {
                t: "Ishlab chiqarish va savdo",
                d: "Katalog to'liq bo'lmasa ham, asosiy mahsulot guruhlari va sertifikatlar ko'rsatiladi. Ulgurji xaridor uchun shu yetarli.",
            },
            {
                t: "Yangi tashkil etilgan kompaniya",
                d: "Bank, tender va hamkorlar rasmiy sayt so'raydi. Vizitka sayt bu talabni bir-ikki haftada, katta byudjetsiz yopadi.",
            },
            {
                t: "Instagram'da sotadiganlar",
                d: "Profildagi havola professional saytga olib borsa, ishonch ortadi. Bundan tashqari sayt kontenti qidiruvda ham ishlaydi.",
            },
            {
                t: "Ta'lim markazlari",
                d: "Kurslar, o'qituvchilar, jadval va ro'yxatdan o'tish shakli. Arizalar Telegram guruhiga tushadi, qo'lda yozib olish shart emas.",
            },
            {
                t: "Filial va ofisga ega bizneslar",
                d: "Har bir manzil uchun xarita, telefon va ish vaqti ko'rsatiladi. Google Business profili bilan ma'lumot bir xil bo'lishi ta'minlanadi.",
            },
            {
                t: "Restoran, kafe va mehmonxonalar",
                d: "Menyu, interyer suratlari, joylashuv va bron shakli. Mijoz kelishdan oldin narx va atmosferani ko'rib oladi, savol bermay bron qiladi.",
            },
        ],
    },
    pricing: {
        eyebrow: "Narxlar",
        h: "Vizitka sayt narxi — uch tarif",
        sub: "Narxlar oshkora. Har bir tarifga domen sozlash, joylashtirish va qo'llab-quvvatlash kiradi.",
        note:
            "Yakuniy hisob-kitob bepul konsultatsiyadan keyin, sahifalar soni va til versiyalariga qarab tasdiqlanadi. To'lov ikki bosqichda: 50% boshida, 50% topshirishda. Domen va hosting to'lovi provayderga alohida — yiliga taxminan 400 000 – 1 200 000 so'm.",
        tiers: [
            {
                name: "Start",
                tagline: "Uch sahifali oddiy sayt",
                price: "5 000 000",
                priceNote: "so'mdan",
                term: "7–10 ish kuni",
                best: "Xususiy mutaxassislar va yangi kichik biznes uchun",
                features: [
                    "3 ta sahifa: bosh, xizmatlar, aloqa",
                    "Tayyor asosda moslashtirilgan dizayn",
                    "Barcha qurilmalarga moslashuv",
                    "Aloqa shakli va Telegram'ga xabar",
                    "Google xaritasi va manzil bloki",
                    "Bazaviy texnik SEO",
                    "Google Analytics ulash",
                    "6 oy qo'llab-quvvatlash",
                ],
            },
            {
                name: "Standart",
                tagline: "Besh sahifa va adminka",
                price: "11 000 000",
                priceNote: "so'mdan",
                term: "10–15 ish kuni",
                best: "Bir nechta xizmat yo'nalishiga ega kompaniyalar uchun",
                featured: true,
                features: [
                    "5 tagacha sahifa va ichki bo'limlar",
                    "Figma'da noldan chizilgan dizayn",
                    "Admin panel: matn, rasm va xizmatlarni o'zingiz tahrirlaysiz",
                    "Ikki tilli versiya (o'zbek va rus)",
                    "Portfolio yoki ishlar galereyasi",
                    "Xizmatlar uchun alohida sahifalar va SEO matni",
                    "Schema.org belgilash va Google Business bog'lanishi",
                    "Ijtimoiy tarmoqlar va messenjer integratsiyasi",
                    "6 oy qo'llab-quvvatlash",
                ],
            },
            {
                name: "Biznes",
                tagline: "Kengaytirilgan vizitka",
                price: "20 000 000",
                priceNote: "so'mdan",
                term: "3–5 hafta",
                best: "Filiallar, uch tillilik yoki blog kerak bo'lganda",
                features: [
                    "7–10 sahifa, blog yoki yangiliklar bo'limi",
                    "Uch tilli versiya (o'zbek, rus, ingliz)",
                    "Filiallar xaritasi va alohida manzil sahifalari",
                    "Kengaytirilgan SEO: kalit so'zlar tahlili va matn",
                    "CRM yoki Google Sheets bilan integratsiya",
                    "Onlayn yozilish yoki bron moduli",
                    "Tezlik va Core Web Vitals optimizatsiyasi",
                    "12 oy qo'llab-quvvatlash",
                ],
            },
        ],
    },
    process: {
        eyebrow: "Jarayon",
        h: "Vizitka sayt qanday yaratiladi",
        sub: "Olti bosqich. Har bosqich oxirida natijani ko'rasiz — keyingisi siz tasdiqlagandan keyin boshlanadi.",
        steps: [
            {
                t: "Konsultatsiya va brif",
                time: "1 kun",
                d: "Faoliyatingiz, mijoz portreti va raqobatchilarni muhokama qilamiz. Necha sahifa kerakligini birgalikda hal qilamiz va aniq narx bilan muddatni belgilaymiz.",
            },
            {
                t: "Tuzilma va kontent rejasi",
                time: "1–2 kun",
                d: "Sahifalar ro'yxati va har bir sahifadagi bloklar tuziladi. Sizdan logotip, rasm va faoliyat haqidagi ma'lumot olamiz — matnni shular asosida yozamiz.",
            },
            {
                t: "Dizayn",
                time: "3–6 kun",
                d: "Figma'da bosh sahifa va ichki sahifalar maketi chiziladi. Rang va shrift brendingizga moslashtiriladi; kelishilgan doirada tuzatishlar bepul.",
            },
            {
                t: "Dasturlash",
                time: "4–8 kun",
                d: "Sayt React asosida yig'iladi, adminka ulanadi, rasmlar siqiladi. Meta teglar va sahifa sarlavhalari har bir sahifa uchun alohida yoziladi.",
            },
            {
                t: "Sinov va ishga tushirish",
                time: "1–2 kun",
                d: "Shakllar, brauzerlar va ekran o'lchamlari qo'lda tekshiriladi. Domen ulanadi, sayt Google'ga yuboriladi, sizga boshqaruv qo'llanmasi topshiriladi.",
            },
            {
                t: "Qo'llab-quvvatlash",
                time: "6 oy",
                d: "Texnik xatolar bepul tuzatiladi, kichik matn va rasm o'zgarishlarini biz kiritamiz. Kerak bo'lsa Google Business profilini to'ldirishda yordam beramiz.",
            },
        ],
    },
    samples: {
        eyebrow: "Namunalar",
        h: "So'nggi ishlarimizdan",
        sub: "Har bir loyiha noldan chizilgan: tuzilma, dizayn, matn va texnik qismi bizniki.",
        cta: "Barcha loyihalar",
        slugs: ["cleanza", "drkim", "scriber-arts", "oikos"],
    },
    faq: {
        eyebrow: "Savol-javob",
        h: "Ko'p beriladigan savollar",
        sub: "Vizitka sayt yaratish bo'yicha eng ko'p so'raladigan savollarga aniq javoblar.",
        items: [
            {
                q: "Vizitka sayt yaratish qancha turadi?",
                a: "Narx 5 000 000 so'mdan boshlanadi — bu uch sahifali, mobilga to'liq mos va indekslanishga tayyor sayt. Beshta sahifa, individual dizayn va admin panel bilan variant 11 000 000 so'mdan. Filiallar, uch tillilik yoki blog kerak bo'lsa, narx 20 000 000 so'mdan boshlanadi.",
            },
            {
                q: "Vizitka sayt necha kunda tayyor bo'ladi?",
                a: "Start tarifi odatda 7–10 ish kunida topshiriladi, Standart tarifi 10–15 ish kunini oladi. Kengaytirilgan variant uchun 3–5 hafta kerak. Muddat sizdan logotip, rasm va ma'lumot qanchalik tez kelishiga bog'liq — kontent tayyor bo'lsa, jarayon bir necha kunga qisqaradi. Muddat shartnomada qayd etiladi va kechikish ehtimoli bo'lsa, oldindan xabar beramiz.",
            },
            {
                q: "Vizitka sayt bilan landing page orasida qanday farq bor?",
                a: "Landing page bitta taklifni reklama ostida sotadi va bitta sahifadan iborat bo'ladi. Vizitka sayt esa kompaniyaning doimiy yuzi: unda bir nechta xizmat, jamoa, litsenziya va manzil uchun alohida sahifalar bo'ladi. Ikki-uchdan ortiq xizmat yo'nalishingiz bo'lsa, vizitka sayt to'g'riroq tanlov. Ikkala format kerak bo'lsa, ularni bitta saytda birlashtiramiz.",
            },
            {
                q: "Necha sahifa bo'lishi kerak?",
                a: "Ko'pchilik kichik biznes uchun to'rt-besh sahifa yetarli: bosh sahifa, xizmatlar, biz haqimizda, ishlar va aloqa. Har bir xizmat uchun alohida sahifa ochish SEO nuqtayi nazaridan foydali, chunki ular turli so'rovlar bo'yicha chiqadi. Sahifalar sonini konsultatsiyada birgalikda aniqlaymiz. Keyinchalik yangi sahifa qo'shish adminka orqali yoki alohida ish sifatida bajariladi.",
            },
            {
                q: "Saytni o'zim tahrirlay olamanmi?",
                a: "Standart va Biznes tariflarda admin panel beriladi: matn, rasm, xizmatlar va narxlarni dasturchisiz o'zgartirasiz. Start tarifida adminka yo'q, lekin olti oylik qo'llab-quvvatlash davomida kichik o'zgartirishlarni biz bepul kiritamiz. Adminkani keyinroq alohida qo'shish ham mumkin. Uning narxi sahifalar soniga bog'liq va odatda 3 000 000 so'mdan boshlanadi.",
            },
            {
                q: "Vizitka sayt Google'da chiqadimi?",
                a: "Sayt indekslanishga tayyor holda topshiriladi: har bir sahifa uchun meta teglar, semantik sarlavhalar, sitemap.xml, robots.txt va Schema.org belgilash o'rnatiladi. Kompaniya nomi bo'yicha odatda bir-ikki hafta ichida chiqasiz. Raqobatli so'rovlar uchun esa doimiy SEO ishi va kontent kerak bo'ladi. Bu ishni oylik hisobot bilan alohida xizmat sifatida olib boramiz.",
            },
            {
                q: "Matnni kim yozadi?",
                a: "Standart va Biznes tariflarda matn narxga kiradi: sizdan brif olamiz, faoliyatingizni o'rganamiz va har bir sahifa uchun matn yozamiz. Start tarifida asosiy ma'lumotni siz berasiz, biz esa uni tahrirlaymiz va sarlavhalarni qayta ishlaymiz. Rasm va logotip har doim sizdan kerak.",
            },
            {
                q: "Ikki tilli sayt qilish mumkinmi?",
                a: "Ha. O'zbek va rus tilidagi versiya Standart tarifdan boshlab kiradi, ingliz tilini qo'shish Biznes tarifida yoki alohida ish sifatida bajariladi. Har bir tilning o'z manzili bo'ladi, bu Google uchun to'g'ri tuzilma. Tarjima matni sizdan yoki bizdan bo'lishi kelishiladi. Til almashtirish tugmasi saytning barcha sahifalarida turadi.",
            },
            {
                q: "Domen va hosting narxga kiradimi?",
                a: "Sozlash ishlari kiradi: domen tanlashda yordam beramiz, DNS'ni ulaymiz, SSL o'rnatamiz. Domen va hosting to'lovi provayderga to'g'ridan-to'g'ri to'lanadi — yiliga taxminan 400 000 – 1 200 000 so'm. Qaysi tarif sizning tashriflaringiz uchun yetarli ekanini aytamiz. Domen sizning nomingizga rasmiylashtiriladi, biz uni o'zimizda saqlamaymiz.",
            },
            {
                q: "Kafolat bormi va nima qamrab olinadi?",
                a: "Topshirishdan keyin olti oy davomida texnik xatolar bepul tuzatiladi: ishlamay qolgan shakl, buzilgan moslashuv, ochilmayotgan sahifa. Bu muddatga kichik matn va rasm almashtirish ham kiradi. Yangi sahifa qo'shish yoki dizaynni qayta chizish alohida ish sifatida oldindan baholanadi. Narxini boshlashdan oldin aytamiz, yashirin qo'shimcha to'lov bo'lmaydi.",
            },
            {
                q: "Vizitka sayt qachon mos kelmaydi?",
                a: "Agar sizda yuzlab mahsulotli katalog, savat va onlayn to'lov kerak bo'lsa, internet-do'kon quriladi. Foydalanuvchi ro'yxatdan o'tadigan va shaxsiy kabinetda ishlaydigan mahsulot uchun veb-ilova to'g'ri yechim. Kundalik yangilanadigan katta kontent uchun esa korporativ sayt kerak bo'ladi. Qaysi format mos kelishini konsultatsiyada ochiq aytamiz va sabablarini tushuntiramiz.",
            },
            {
                q: "Toshkentdan tashqarida bo'lsam ishlay olasizmi?",
                a: "Ha. Loyihalarning katta qismi masofadan olib boriladi: muloqot Telegram va onlayn uchrashuvlar orqali, hujjatlar elektron shaklda rasmiylashtiriladi. O'zbekistonning istalgan viloyatidan hamda chet eldan buyurtma qabul qilamiz. Bog'lanish uchun: +998 90 954 12 62. Shartnoma va hisob-faktura O'zbekiston qonunchiligi bo'yicha rasmiylashtiriladi. Toshkentda ofisda uchrashish ham mumkin.",
            },
        ],
    },
    cta: {
        h: "Vizitka sayt buyurtma qilasizmi?",
        p: "Bepul konsultatsiyada faoliyatingizni muhokama qilamiz, necha sahifa kerakligini aytamiz va aniq narx bilan muddatni belgilaymiz. Majburiyat yo'q. Telefon: +998 90 954 12 62.",
        button: "Bepul konsultatsiya olish",
        secondary: "Telegram orqali yozish",
    },
    images: [
        {
            src: "/assets/img/blog/cleanza-cover.webp",
            alt: "Kichik biznes uchun vizitka sayt bosh sahifasi telefon va noutbukda",
            caption: "Vizitka sayt avval telefon ekrani uchun chiziladi, keyin kompyuterga kengaytiriladi.",
        },
        {
            src: "/assets/img/projects/cleanza.webp",
            alt: "Cleanza tozalash xizmati uchun vizitka sayt: xizmatlar va aloqa sahifasi",
            caption: "Cleanza — xizmat kompaniyasi uchun besh sahifali vizitka sayt.",
        },
        {
            src: "/assets/img/projects/drkim.webp",
            alt: "Dr Kim klinikasi uchun vizitka sayt: shifokorlar, narxlar va manzil",
            caption: "Dr Kim — klinika uchun litsenziya va jamoa sahifalari bilan sayt.",
        },
        {
            src: "/assets/img/blog/cleanza-xizmatlar.webp",
            alt: "Vizitka saytdagi xizmatlar sahifasi tuzilmasi va narxlar bloki",
            caption: "Har bir xizmat uchun alohida sahifa qidiruvda alohida so'rov bo'yicha ishlaydi.",
        },
        {
            src: "/assets/img/projects/scriber-arts.webp",
            alt: "Scriber Arts studiyasi uchun portfolio bo'limli vizitka sayt namunasi",
            caption: "Scriber Arts — ishlar galereyasiga urg'u berilgan vizitka sayt.",
        },
    ],
    related: ["landing-page", "korporativ-saytlar", "google-business", "seo", "ux-ui-dizayn"],
};

const ru = {
    meta: {
        title: "Сайт-визитка — создание от 5 млн сум | Innobek",
        description:
            "Сайт-визитка от 5 000 000 сум. Сайт на 3–5 страниц для малого бизнеса и специалистов за 7–12 дней: мобильная адаптация, форма связи, карта Google.",
        keywords: [
            "сайт-визитка",
            "создание сайта-визитки",
            "цена сайта-визитки",
            "сайт для малого бизнеса",
            "сайт на 3 страницы",
            "заказать сайт Ташкент",
        ],
    },
    hero: {
        eyebrow: "Сайты-визитки",
        h1: "Сайт-визитка для малого бизнеса — 3–5 страниц",
        lead:
            "О компании, услуги, работы и контакты — каждый раздел на своей странице, без лишней сложности. Сайт-визитку сдаём за 7–12 рабочих дней: она безупречно открывается на телефоне и готова к тому, чтобы её находили в Google.",
        ctaPrimary: "Бесплатная консультация",
        ctaSecondary: "Посмотреть цены",
        proof: [
            "Сдача за 7–12 дней",
            "От 3 до 5 страниц",
            "Карта Google и часы работы",
            "6 месяцев техподдержки",
        ],
    },
    intro: {
        h: "Что такое сайт-визитка и кому он нужен",
        p: [
            "Сайт-визитка — небольшой сайт на 3–5 страниц, который рассказывает главное о компании или специалисте. Обычно это главная, услуги, о нас, работы и контакты. Здесь нет большого каталога, системы заказов и ежедневно обновляемых разделов — поэтому и цена, и срок заметно ниже, чем у корпоративного сайта.",
            "Такой сайт отвечает на один вопрос: кто вы и почему вам можно доверять. Когда клиент находит вас через Instagram или по рекомендации, первое, что он делает, — вбивает название в Google. Если там открывается официальный сайт, доверие резко растёт. Если сайта нет, клиент уходит к конкуренту, у которого он есть.",
            "Innobek не относится к визитке как к заполнению шаблона. Сначала мы разбираемся, чем вы занимаетесь, кто ваш клиент и какая информация для него важна. Под это выстраиваем структуру страниц: лишние разделы не добавляем, нужные не ужимаем. Текст, фотографии и кнопки работают на одну задачу — упростить обращение.",
            "Разница между визиткой и лендингом простая. Лендинг продаёт одно предложение под рекламный трафик и умещается на одной странице. Сайт-визитка — постоянное лицо компании: отдельные страницы под услуги, команду, лицензии и адрес. Если направлений больше двух-трёх, одной страницы уже не хватает.",
            "Скажем честно: сама визитка клиентов не приводит. Она укрепляет доверие и упрощает контакт. Чтобы шёл трафик, нужны профиль Google Business, SEO или реклама. Поэтому мы сдаём сайт подключённым к Google Business и Search Console — чтобы по названию компании вас находили сразу.",
        ],
    },
    definition: {
        term: "Что такое сайт-визитка?",
        text:
            "Сайт-визитка — небольшой сайт на 3–5 страниц с основной информацией о компании или специалисте. Его задача — объяснить, чем вы занимаетесь, вызвать доверие и показать клиенту, как с вами связаться.",
    },
    included: {
        eyebrow: "Что входит",
        h: "Входит в каждый тариф по умолчанию",
        sub: "Это не платные опции — они есть и в базовом тарифе.",
        items: [
            "Бесплатная консультация и планирование структуры страниц",
            "Помощь с выбором домена и настройка DNS",
            "Бесплатный SSL-сертификат и работа по HTTPS",
            "Адаптация под телефон, планшет и десктоп",
            "Форма связи с уведомлением в Telegram",
            "Карта Google с адресом, часами работы и маршрутом",
            "Метатеги, sitemap.xml, robots.txt и изображение Open Graph",
            "Подключение Google Analytics и Search Console",
            "Кнопки соцсетей и мессенджеров",
            "6 месяцев техподдержки после сдачи",
        ],
    },
    benefits: {
        eyebrow: "Преимущества",
        h: "Почему малому бизнесу достаточно сайта-визитки",
        sub: "Большой сайт не всегда окупается. Ниже — в чём практическая сила компактного формата.",
        items: [
            {
                t: "Понятный бюджет заранее",
                d: "Число страниц ограничено, поэтому смета согласуется в начале целиком. Цена более чем вдвое ниже, чем у корпоративного сайта, а доплат по ходу работы не появляется.",
            },
            {
                t: "Готов за одну-две недели",
                d: "Вариант на три страницы сдаём за 7 рабочих дней, пять страниц с индивидуальным дизайном — за 10–12. Успеваете к началу сезона или к дедлайну тендера.",
            },
            {
                t: "Повышает доверие",
                d: "Официальный сайт, ИНН, адрес и копия лицензии снимают часть сомнений клиента. В медицине, юридических услугах и строительстве это напрямую влияет на число обращений.",
            },
            {
                t: "Находится по названию в Google",
                d: "По запросу с названием компании в выдаче первым появляется ваш сайт, а не ссылка на соцсеть или карточка в стороннем каталоге. Связываем сайт с профилем Google Business.",
            },
            {
                t: "Вы не зависите от соцсетей",
                d: "Если аккаунт в Instagram заблокируют или угонят, клиентам будет некуда обратиться. Сайт принадлежит вам, и никто посторонний не может его удалить.",
            },
            {
                t: "Мобильные в приоритете",
                d: "Большая часть визитов приходит с телефона, поэтому макет рисуется сначала под мобильный экран. Нажатие на номер запускает звонок, нажатие на адрес открывает карту.",
            },
            {
                t: "Можно расширять",
                d: "Когда появятся новые услуги, блог или каталог, разделы добавляются к существующему сайту. Дизайн-система переиспользуется, поэтому расширение дешевле разработки с нуля.",
            },
            {
                t: "Код и материалы остаются у вас",
                d: "При сдаче передаём домен, доступы к хостингу, макет в Figma и архив кода. Вы не привязаны к нам — вести сайт при желании сможет другая команда.",
            },
        ],
    },
    audience: {
        eyebrow: "Кому подходит",
        h: "Кому сайт-визитка полезнее всего",
        sub: "В этих случаях компактный сайт даёт результат быстрее и дешевле любого другого формата.",
        items: [
            {
                t: "Частные специалисты",
                d: "Адвокат, врач, психолог, репетитор, дизайнер, фотограф. Портфолио, список услуг и форма записи — каждый блок на своей странице.",
            },
            {
                t: "Небольшие сервисные компании",
                d: "Ремонт, логистика, бухгалтерия, юридические услуги, клининг. Если направлений два-три, под каждое выделяется отдельная страница.",
            },
            {
                t: "Клиники и салоны",
                d: "Услуги и цены, команда, лицензии, адрес и часы работы. Клиент получает ответы на все вопросы ещё до визита.",
            },
            {
                t: "Производство и оптовая торговля",
                d: "Даже без полного каталога показываются основные группы продукции и сертификаты. Оптовому покупателю этого обычно достаточно.",
            },
            {
                t: "Только что открывшаяся компания",
                d: "Банки, тендеры и партнёры спрашивают официальный сайт. Визитка закрывает это требование за одну-две недели и без большого бюджета.",
            },
            {
                t: "Продажи через Instagram",
                d: "Ссылка в профиле, ведущая на полноценный сайт, добавляет доверия. Плюс содержимое сайта начинает работать и в поиске.",
            },
            {
                t: "Учебные центры",
                d: "Курсы, преподаватели, расписание и форма записи. Заявки приходят в Telegram-группу, вести список вручную не нужно.",
            },
            {
                t: "Бизнес с филиалами",
                d: "Для каждого адреса показываются карта, телефон и часы работы. Данные синхронизируются с профилем Google Business.",
            },
            {
                t: "Рестораны, кафе и отели",
                d: "Меню, фотографии интерьера, расположение и форма брони. Гость заранее видит цены и атмосферу и бронирует, не задавая вопросов.",
            },
        ],
    },
    pricing: {
        eyebrow: "Цены",
        h: "Стоимость сайта-визитки — три тарифа",
        sub: "Цены открытые. В каждый тариф входят настройка домена, размещение и поддержка.",
        note:
            "Итоговая смета подтверждается после бесплатной консультации и зависит от числа страниц и языковых версий. Оплата в два этапа: 50% в начале, 50% при сдаче. Домен и хостинг оплачиваются провайдеру отдельно — примерно 400 000 – 1 200 000 сум в год.",
        tiers: [
            {
                name: "Start",
                tagline: "Простой сайт на три страницы",
                price: "5 000 000",
                priceNote: "сум",
                term: "7–10 рабочих дней",
                best: "Частным специалистам и новому малому бизнесу",
                features: [
                    "3 страницы: главная, услуги, контакты",
                    "Дизайн на готовой основе под ваш бренд",
                    "Адаптация под все устройства",
                    "Форма связи и уведомления в Telegram",
                    "Блок с картой Google и адресом",
                    "Базовое техническое SEO",
                    "Подключение Google Analytics",
                    "6 месяцев поддержки",
                ],
            },
            {
                name: "Стандарт",
                tagline: "Пять страниц и админка",
                price: "11 000 000",
                priceNote: "сум",
                term: "10–15 рабочих дней",
                best: "Компаниям с несколькими направлениями услуг",
                featured: true,
                features: [
                    "До 5 страниц и внутренние разделы",
                    "Дизайн с нуля в Figma",
                    "Админка: тексты, изображения и услуги меняете сами",
                    "Две языковые версии (узбекский и русский)",
                    "Портфолио или галерея работ",
                    "Отдельные страницы услуг с SEO-текстами",
                    "Разметка Schema.org и связка с Google Business",
                    "Интеграция соцсетей и мессенджеров",
                    "6 месяцев поддержки",
                ],
            },
            {
                name: "Бизнес",
                tagline: "Расширенная визитка",
                price: "20 000 000",
                priceNote: "сум",
                term: "3–5 недель",
                best: "Когда нужны филиалы, три языка или блог",
                features: [
                    "7–10 страниц, раздел блога или новостей",
                    "Три языковые версии (узбекский, русский, английский)",
                    "Карта филиалов и отдельные страницы адресов",
                    "Расширенное SEO: сбор запросов и тексты",
                    "Интеграция с CRM или Google Sheets",
                    "Модуль онлайн-записи или брони",
                    "Оптимизация скорости и Core Web Vitals",
                    "12 месяцев поддержки",
                ],
            },
        ],
    },
    process: {
        eyebrow: "Процесс",
        h: "Как мы делаем сайт-визитку",
        sub: "Шесть этапов. В конце каждого вы видите результат — следующий начинается после вашего согласования.",
        steps: [
            {
                t: "Консультация и бриф",
                time: "1 день",
                d: "Обсуждаем вашу деятельность, портрет клиента и конкурентов. Вместе решаем, сколько страниц нужно, и фиксируем точную цену и срок.",
            },
            {
                t: "Структура и план контента",
                time: "1–2 дня",
                d: "Составляем список страниц и блоков на каждой. Берём у вас логотип, фотографии и сведения о работе — тексты пишем на их основе.",
            },
            {
                t: "Дизайн",
                time: "3–6 дней",
                d: "Рисуем в Figma главную и внутренние страницы. Цвета и шрифты подстраиваем под бренд, правки в согласованном объёме бесплатны.",
            },
            {
                t: "Разработка",
                time: "4–8 дней",
                d: "Собираем сайт на React, подключаем админку, сжимаем изображения. Метатеги и заголовки прописываем для каждой страницы отдельно.",
            },
            {
                t: "Тесты и запуск",
                time: "1–2 дня",
                d: "Вручную проверяем формы, браузеры и размеры экранов. Подключаем домен, отправляем сайт в Google, передаём инструкцию по управлению.",
            },
            {
                t: "Поддержка",
                time: "6 месяцев",
                d: "Технические ошибки правим бесплатно, мелкие изменения текста и фото вносим сами. При необходимости помогаем заполнить профиль Google Business.",
            },
        ],
    },
    samples: {
        eyebrow: "Примеры",
        h: "Из недавних работ",
        sub: "Каждый проект сделан с нуля: структура, дизайн, тексты и техническая часть — наши.",
        cta: "Все проекты",
        slugs: ["cleanza", "drkim", "scriber-arts", "oikos"],
    },
    faq: {
        eyebrow: "Вопросы и ответы",
        h: "Частые вопросы",
        sub: "Конкретные ответы на то, что чаще всего спрашивают про создание сайта-визитки.",
        items: [
            {
                q: "Сколько стоит сайт-визитка?",
                a: "Цена начинается от 5 000 000 сум — это три страницы, полная адаптация под мобильные и готовность к индексации. Вариант на пять страниц с индивидуальным дизайном и админкой — от 11 000 000 сум. Если нужны филиалы, три языка или блог, стоимость начинается от 20 000 000 сум.",
            },
            {
                q: "За сколько дней делается сайт-визитка?",
                a: "Тариф Start обычно сдаётся за 7–10 рабочих дней, Стандарт — за 10–15. Расширенный вариант занимает 3–5 недель. Срок зависит и от того, как быстро вы передадите логотип, фотографии и информацию — с готовым контентом процесс короче на несколько дней.",
            },
            {
                q: "Чем сайт-визитка отличается от лендинга?",
                a: "Лендинг продаёт одно предложение под рекламный трафик и умещается на одной странице. Визитка — постоянное лицо компании: отдельные страницы под услуги, команду, лицензии и адрес. Если у вас больше двух-трёх направлений, визитка подходит лучше. При необходимости оба формата совмещаются в рамках одного сайта.",
            },
            {
                q: "Сколько страниц должно быть?",
                a: "Большинству небольших компаний хватает четырёх-пяти: главная, услуги, о нас, работы и контакты. Отдельная страница под каждую услугу полезна для поиска — такие страницы ранжируются по разным запросам. Итоговое количество определяем вместе на консультации. Добавить страницу позже можно через админку или отдельной доработкой.",
            },
            {
                q: "Смогу ли я сам редактировать сайт?",
                a: "В тарифах Стандарт и Бизнес есть админка: тексты, изображения, услуги и цены меняются без программиста. В тарифе Start админки нет, но в течение шести месяцев поддержки мелкие правки мы вносим бесплатно. Админку можно подключить и позже отдельной доработкой. Стоимость зависит от числа страниц и начинается примерно от 3 000 000 сум.",
            },
            {
                q: "Будет ли сайт-визитка видна в Google?",
                a: "Сайт сдаётся готовым к индексации: метатеги для каждой страницы, семантические заголовки, sitemap.xml, robots.txt и разметка Schema.org. По названию компании вы обычно появляетесь в выдаче за одну-две недели. Для конкурентных запросов нужна постоянная SEO-работа и контент. Эту работу мы ведём отдельной услугой с ежемесячным отчётом.",
            },
            {
                q: "Кто пишет тексты?",
                a: "В тарифах Стандарт и Бизнес тексты входят в цену: берём бриф, изучаем вашу сферу и пишем текст под каждую страницу. В тарифе Start основную информацию даёте вы, а мы редактируем её и переписываем заголовки. Фотографии и логотип нужны от вас в любом случае.",
            },
            {
                q: "Можно сделать сайт на двух языках?",
                a: "Да. Узбекская и русская версии входят начиная с тарифа Стандарт, английскую добавляем в тарифе Бизнес или отдельной доработкой. У каждого языка свой адрес — это корректная структура для Google. Заранее согласуем, кто готовит перевод: вы или мы. Переключатель языка доступен на всех страницах сайта.",
            },
            {
                q: "Домен и хостинг входят в цену?",
                a: "Работы по настройке входят: помогаем выбрать домен, подключаем DNS, устанавливаем SSL. Оплата домена и хостинга идёт провайдеру напрямую — примерно 400 000 – 1 200 000 сум в год. Подскажем, какого тарифа хватит под вашу посещаемость. Домен оформляется на вас, у себя мы его не держим.",
            },
            {
                q: "Есть ли гарантия и что в неё входит?",
                a: "Полгода после сдачи технические ошибки исправляются бесплатно: неработающая форма, съехавшая вёрстка, недоступная страница. В этот же срок входит замена текстов и фотографий. Добавление новых страниц или переработка дизайна оцениваются заранее как отдельная работа. Цену называем до начала и получаем ваше подтверждение — скрытых доплат не бывает.",
            },
            {
                q: "Когда сайт-визитка не подходит?",
                a: "Если нужен каталог на сотни товаров с корзиной и онлайн-оплатой, делается интернет-магазин. Для продукта, где пользователь регистрируется и работает в личном кабинете, правильное решение — веб-приложение. А под ежедневно обновляемый объёмный контент нужен корпоративный сайт. На консультации прямо скажем, какой формат вам подходит и почему.",
            },
            {
                q: "Работаете ли вы с клиентами не из Ташкента?",
                a: "Да. Большую часть проектов ведём удалённо: общение в Telegram и на онлайн-встречах, документы оформляем электронно. Принимаем заказы из любого региона Узбекистана и из-за рубежа. Телефон для связи: +998 90 954 12 62. Договор и счёт оформляем по законодательству Узбекистана. При желании встречаемся в офисе в Ташкенте.",
            },
        ],
    },
    cta: {
        h: "Обсудим ваш будущий сайт?",
        p: "На бесплатной консультации разберём вашу сферу, скажем, сколько страниц нужно, и зафиксируем точную цену и срок. Без обязательств. Телефон: +998 90 954 12 62.",
        button: "Получить консультацию",
        secondary: "Написать в Telegram",
    },
    images: [
        {
            src: "/assets/img/blog/cleanza-cover.webp",
            alt: "Главная страница сайта-визитки для малого бизнеса на телефоне и ноутбуке",
            caption: "Визитка рисуется сначала под мобильный экран и затем расширяется до десктопа.",
        },
        {
            src: "/assets/img/projects/cleanza.webp",
            alt: "Сайт-визитка клининговой компании Cleanza: страницы услуг и контактов",
            caption: "Cleanza — сайт-визитка сервисной компании на пять страниц.",
        },
        {
            src: "/assets/img/projects/drkim.webp",
            alt: "Сайт-визитка клиники Dr Kim: врачи, цены и адрес на карте",
            caption: "Dr Kim — сайт клиники со страницами команды и лицензий.",
        },
        {
            src: "/assets/img/blog/cleanza-xizmatlar.webp",
            alt: "Структура страницы услуг на сайте-визитке и блок с ценами",
            caption: "Отдельная страница под каждую услугу работает в поиске по своему запросу.",
        },
        {
            src: "/assets/img/projects/scriber-arts.webp",
            alt: "Пример сайта-визитки студии Scriber Arts с разделом портфолио",
            caption: "Scriber Arts — визитка с упором на галерею выполненных работ.",
        },
    ],
    related: ["landing-page", "korporativ-saytlar", "google-business", "seo", "ux-ui-dizayn"],
};

const content = { uz, ru };

export default content;
